import IconDoubleArrowRight from "@shared/components/icons/DoubleArrowRight"
import IconTrashBin from "@shared/components/icons/TrashBin"
import { ChoiceButtons } from "@shared/components/menus/views/ChoiceButtons"
import { ViewShell } from "@shared/components/menus/views/ViewShell"

/**
 * What should happen to the day's lesson when the class doesn't meet — the same two answers
 * `courseCalendarEditor.turnOffAndBumpDeleteOrNothing` takes, so the choice reaches it
 * untranslated. (Its third, "NO_LESSON", is not a choice: it means the day had no lesson.)
 */
export type BumpOrDelete = "BUMP" | "DELETE"

/**
 * "What should happen to the lesson?" — the first step of removing a class from a day that
 * already has a lesson planned on it.
 */
export function BumpOrDeleteView({ onChoose }: { onChoose: (choice: BumpOrDelete) => void }) {
  return (
    <ViewShell>
      <div className="px-5 pt-4 pb-5">
        <ChoiceButtons<BumpOrDelete>
          ariaLabel="What should happen to the lesson?"
          onChoose={onChoose}
          options={[
            {
              value: "BUMP",
              label: "Bump Lesson Forward",
              description: "Moves to the next session",
              icon: IconDoubleArrowRight,
            },
            {
              value: "DELETE",
              label: "Delete the lesson",
              description: "Removes it entirely",
              icon: IconTrashBin,
            },
          ]}
        />
      </div>
    </ViewShell>
  )
}
